import { connect } from "react-redux"
import React, { Component } from 'react';
import './Common.css';
import './ViewProposal.css';
import { betStatusFromDatabase, changeTextInput, updateEthPrice, changePageContext, setVersionStatus, restoreTextInput, versionBetProposal, addComment, changeSelectedVersion, showOverlay, acceptNewArbiter, requestNewArbiter, rejectNewArbiter, createBetFromInput } from "../actions/betActions"
import DatePickerInput from './DatePickerInput';
import TextCurrencyInput from './TextCurrencyInput';
import DropdownMenu from './DropdownMenu';
import loading from '../loading2.gif';
import BetControls from './BetControls';

const stateMap = (store) => {
    return {
        textInputData: store.bet.textInputData,
        pageContext: store.bet.pageContext,
        authentication: store.bet.authentication,
        ethPrice: store.bet.ethPrice,
        blockchainDataMap: store.bet.blockchainDataMap
    };
};
class ViewProposal extends Component {
    constructor(props) {
        super(props);

        // This binding is necessary to make `this` work in the callback
        this.changeTextInput = this.changeTextInput.bind(this);
        this.addComment = this.addComment.bind(this);
        this.showComments = this.showComments.bind(this);
        this.getContext = this.getContext.bind(this);
        this.getInput = this.getInput.bind(this);
        this.handleDateChange = this.handleDateChange.bind(this);
        this.edit = this.edit.bind(this);
        this.proposeArbiter = this.proposeArbiter.bind(this);
        this.reviewArbiter = this.reviewArbiter.bind(this);
        this.acceptVersion = this.acceptVersion.bind(this);
        this.rejectVersion = this.rejectVersion.bind(this);
        this.cancelEdit = this.cancelEdit.bind(this);
        this.submitVersion = this.submitVersion.bind(this);
        this.finalize = this.finalize.bind(this);
        this.changeSelectedVersion = this.changeSelectedVersion.bind(this);
        this.acceptNewArbiter = this.acceptNewArbiter.bind(this);
        this.cancelNewArbiter = this.cancelNewArbiter.bind(this);
        this.rejectNewArbiter = this.rejectNewArbiter.bind(this);
        this.betControlAction = this.betControlAction.bind(this);
    }

    componentDidMount() {
        this.props.dispatch(updateEthPrice());

        const context = this.getContext();

        let participant1 = context.participant1;
        let participant2 = context.participant2;
        let username = this.props.authentication.username;
        let opponent = (participant1 !== username ? participant1 : participant2);

        let opponentRequestedArbiter = (context.requestedArbiter.hasOwnProperty(opponent) && context.requestedArbiter[opponent]) || "";

        if(opponentRequestedArbiter) {
            this.reviewArbiter();
        }
    }

    getContext() {
        let { VIEW_PROPOSAL_CONTEXT={} } = this.props.pageContext;
        let { twoWayVerified=[], final=false, submitted=false, finalize={}, betId="", pendingLoadProposalData=true, step="VIEW", yourStatus="", createVersionStarted=false, keyProposal="", keyUsername="", usd_amount1="", usd_amount2="", usd_arbitrationFee="", participant1="", participant2="", arbiter="", versionList=[], keyVersion="", versionData={}, versionStatus={}, comments={}, cacheInput=null, pendingComment=false, pendingStatusUpdate=false, pendingFinalize=false, requestedArbiter={}, rejectedArbiter={}, pendingAcceptNewArbiter=false, pendingRequestNewArbiter=false } = VIEW_PROPOSAL_CONTEXT;

        let combinedStatus = betStatusFromDatabase(keyUsername, keyProposal);

        return { combinedStatus, twoWayVerified, final, submitted, finalize, betId, pendingLoadProposalData, step, yourStatus, createVersionStarted, keyProposal, keyUsername, usd_amount1, usd_amount2, usd_arbitrationFee, participant1, participant2, arbiter, versionList, keyVersion, versionData, versionStatus, comments, cacheInput, pendingComment, pendingStatusUpdate, pendingFinalize, requestedArbiter, rejectedArbiter, pendingAcceptNewArbiter, pendingRequestNewArbiter };
    }

    getInput() {
        let { VIEW_PROPOSAL={} } = this.props.textInputData;
        let { amount1="", amount2="", betText="", arbiter="", arbitrationFee="", daysBeforeDefaultJudgement="", betExpiresDate="", arbitrationRequestDate="", newComment="" } = VIEW_PROPOSAL;

        return { amount1, amount2, betText, arbiter, arbitrationFee, daysBeforeDefaultJudgement, betExpiresDate, arbitrationRequestDate, newComment };
    }

    handleDateChange(name, value) {
        this.props.dispatch(changeTextInput(name, value, "VIEW_PROPOSAL"));
    }

    changeSelectedVersion(keyNewVersion) {
        this.props.dispatch(changeSelectedVersion(this.props.authentication, keyNewVersion));
    }

    betControlAction(name, param) {

    }

    changeTextInput(event) {
        let name = event.target.name;
        let value = event.target.value;
        let filter = "";
        let filterDots = false;

        if(name === "participant2") { filter = /[^a-zA-Z0-9_]/gi; }
        if(name === "amount1") { filter = /[^0-9.]/gi; filterDots = true; }
        if(name === "amount2") { filter = /[^0-9.]/gi; filterDots = true; }
        if(name === "arbiter") { filter = /[^a-zA-Z0-9_]/gi; }
        if(name === "arbitrationFee") { filter = /[^0-9.]/gi; filterDots = true; }
        if(name === "daysBeforeDefaultJudgement") { filter = /[^0-9]/gi; }

        value = value.replace(filter, "");
        if(filterDots) {
            value = value.replace(/\.(\.)+/gi, ".");
            if(value.length > 0 && value[0] === '.') {
                value = "0" + value;
            }

            if(value.length > 10) {
                value = value.substring(0, 10);
            }
        }

        this.props.dispatch(changeTextInput(name, value, "VIEW_PROPOSAL"));

        if(name === "amount1" || name === "amount2" || name === "arbitrationFee") {
            this.props.dispatch(updateEthPrice());
        }
    }

    acceptNewArbiter(event) {
        let context = this.getContext();
        this.props.dispatch(acceptNewArbiter(this.props.authentication.uuid, context.keyUsername, context.keyProposal, event.target.getAttribute("arbiter")));
    }

    cancelNewArbiter(event) {
        let context = this.getContext();
        this.props.dispatch(requestNewArbiter(this.props.authentication.uuid, context.keyUsername, context.keyProposal, ""));
    }

    rejectNewArbiter(event) {
        let context = this.getContext();
        this.props.dispatch(rejectNewArbiter(this.props.authentication.uuid, context.keyUsername, context.keyProposal, event.target.getAttribute("arbiter")));
    }

    addComment(event) {
        const context = this.getContext();
        const input = this.getInput();
        
        if(input.newComment !== "" && context.pendingComment === false) {
            this.props.dispatch(addComment(this.props.authentication.uuid, context.keyUsername, context.keyProposal, input.newComment));
        }
    }

    showComments(event) {
        window.scrollTo(0, document.body.scrollHeight);
    }

    edit() {
        let { VIEW_PROPOSAL={} } = this.props.textInputData;
        this.props.dispatch(changePageContext({step: "EDIT", cacheInput: VIEW_PROPOSAL }, "VIEW_PROPOSAL"));
    }

    proposeArbiter() {
        this.props.dispatch(showOverlay(true));
        this.props.dispatch(changePageContext({changeArbiterOverlay: true}, "VIEW_PROPOSAL"));        
    }

    reviewArbiter() {
        this.props.dispatch(showOverlay(true));
        this.props.dispatch(changePageContext({reviewArbiterOverlay: true}, "VIEW_PROPOSAL"));        
    }

    acceptVersion() {
        const context = this.getContext();
        this.props.dispatch(setVersionStatus(this.props.authentication.uuid, "ACCEPTED", context.keyUsername, context.keyProposal, context.keyVersion));
    }

    rejectVersion() {
        const context = this.getContext();
        this.props.dispatch(setVersionStatus(this.props.authentication.uuid, "REJECTED", context.keyUsername, context.keyProposal, context.keyVersion));
    }

    cancelEdit() {
        const context = this.getContext();

        if(context.cacheInput !== null) {
            this.props.dispatch(restoreTextInput(context.cacheInput, "VIEW_PROPOSAL"));
        }

        this.props.dispatch(changePageContext({step: "VIEW" }, "VIEW_PROPOSAL"));
    }

    submitVersion(event) {
        const context = this.getContext();
        const input = this.getInput();
        
        this.props.dispatch(versionBetProposal(
            this.props.authentication.uuid, 
            this.props.authentication.username, 
            context.keyUsername, 
            context.keyProposal, 
            input.betText, 
            input.amount1, 
            input.amount2, 
            input.arbitrationFee, 
            input.betExpiresDate, 
            input.arbitrationRequestDate, 
            input.daysBeforeDefaultJudgement));
    }

    finalize() {
        if(this.props.authentication.hasMetamask && this.props.authentication.ethAccount !== "") {
            this.props.dispatch(createBetFromInput(this.getInput(), this.getContext(), this.props.authentication));
        }
    }

    render() {  
        const context = this.getContext();
        const input = this.getInput();
        let betId = context.betId;

        if(context.pendingLoadProposalData) {
            return (<div className="moveTop40 center"><img src={loading} className="loadIcon" alt="loading" /></div>);
        }
        else {
            let combinedStatus = context.combinedStatus;
            let participant1 = context.participant1;
            let participant2 = context.participant2;
            let username = this.props.authentication.username;
            let opponent = (participant1 !== username ? participant1 : participant2);

            let usernameRequestedArbiter = (context.requestedArbiter.hasOwnProperty(username) && context.requestedArbiter[username]) || "";
            let opponentRequestedArbiter = (context.requestedArbiter.hasOwnProperty(opponent) && context.requestedArbiter[opponent]) || "";
            let opponentRejectedArbiter = (context.rejectedArbiter.hasOwnProperty(opponent) && context.rejectedArbiter[opponent]) || "";
            let disableEditing = (context.step !== "EDIT" || context.createVersionStarted === true || opponentRequestedArbiter !== "");
            let disableButtons = context.pendingStatusUpdate || context.createVersionStarted || context.pendingAcceptNewArbiter || context.pendingRequestNewArbiter || context.pendingFinalize;

            let statusList = [];
            if(username === participant1) {
                statusList.push({status:context.versionStatus[participant1], twitterName:participant1});
                statusList.push({status:context.versionStatus[participant2], twitterName:participant2});
                statusList.push({status:context.versionStatus[context.arbiter], twitterName:context.arbiter});
            }
            else if(username === participant2) {
                statusList.push({status:context.versionStatus[participant2], twitterName:participant2});
                statusList.push({status:context.versionStatus[participant1], twitterName:participant1});
                statusList.push({status:context.versionStatus[context.arbiter], twitterName:context.arbiter});
            }
            else if(username === context.arbiter) {
                statusList.push({status:context.versionStatus[context.arbiter], twitterName:context.arbiter});
                statusList.push({status:context.versionStatus[participant1], twitterName: participant1});
                statusList.push({status:context.versionStatus[participant2], twitterName:participant2});
            }
            else {
                statusList.push({status:context.versionStatus[participant1], twitterName:participant1});
                statusList.push({status:context.versionStatus[participant2], twitterName:participant2});
                statusList.push({status:context.versionStatus[context.arbiter], twitterName:context.arbiter});
            }

            let selectedVersionNumber = 0;
            let usernameAcceptedVersion = 0;
            let opponentAcceptedVersion = 0;
            let arbiterAcceptedVersion = 0;
            let everyoneAcceptedVersion = 0;
            let usernameAcceptedKeyVersion = "";
            let everyoneAcceptedKeyVersion = "";
            let versionDropdownList = [];
            for(let i=0; i<context.versionList.length; i++) {
                let entry = context.versionList[i];
                let versionNumber = i+1;
                versionDropdownList.push({name:entry.keyVersion, text:"Version " + versionNumber + ": @" + entry.proposedBy + (entry.hasOwnProperty("createDate") ? " on " + entry.createDate : "")});
                let statusObj = entry.status;

                if(entry.keyVersion === context.keyVersion) {
                    selectedVersionNumber = versionNumber;
                }

                if(statusObj.hasOwnProperty(username) && statusObj[username] === "ACCEPTED") {
                    usernameAcceptedVersion = versionNumber;
                    usernameAcceptedKeyVersion = entry.keyVersion;
                }
                
                if(statusObj.hasOwnProperty(opponent) && statusObj[opponent] === "ACCEPTED") {
                    opponentAcceptedVersion = versionNumber;
                }

                if(statusObj.hasOwnProperty(context.arbiter) && statusObj[context.arbiter] === "ACCEPTED") {
                    arbiterAcceptedVersion = versionNumber;
                }
            }

            if(usernameAcceptedVersion === opponentAcceptedVersion && usernameAcceptedVersion === arbiterAcceptedVersion) {
                everyoneAcceptedVersion = usernameAcceptedVersion;
                everyoneAcceptedKeyVersion = usernameAcceptedKeyVersion;
            }

            let commentCount = Object.keys(context.comments || {}).length;
            let submittedOrFinal = context.final || context.submitted;

            return (
                <div>
                <div className="section">
                    {!submittedOrFinal && <div className="sectionTitle">Proposed bet between @{context.participant1} and @{context.participant2}</div>}
                    {submittedOrFinal && <BetControls dispatch={this.props.dispatch} combinedStatus={combinedStatus} betId={betId} onClick={this.betControlAction} />}
                    {!submittedOrFinal && (
                    <table className="moveTop20"><tbody>
                        <tr>
                            <td className="padAfter20"><label className="labelInput">Current version</label></td>
                        </tr>
                        <tr>
                            <td className="padAfter20">
                                <DropdownMenu selected={context.keyVersion} list={versionDropdownList} onChange={this.changeSelectedVersion} />
                                <span className="linkBtn moveLeft20" onClick={this.showComments}>{commentCount === 1 ? "1 comment" : commentCount + " comments"}</span>
                            </td>
                        </tr>
                        <tr>
                            <td className="padAfter20"><label style={{marginBottom:"0px"}} className="labelInput moveTop20">Status</label></td>
                        </tr>
                        <tr>
                            <td className="">
                                <div className="">
                                    {statusList.map((data, index)=>{
                                        return <label 
                                            style={{marginRight:(index < 2 ? "20px" : "0px")}} className={data.status === "ACCEPTED" ? "statusAccepted" : (data.status === "REJECTED" ? "statusRejected" : "statusAwaiting")} 
                                            key={index}>@{data.twitterName}:{data.status === "ACCEPTED" ? " accepted" : (data.status === "REJECTED" ? " rejected" : " no reply")}</label>;
                                    })}
                                </div>
                            </td>
                        </tr>
                    </tbody></table>
                    )}

                    <table className="moveTop20"><tbody>
                        <tr>
                            <td className="padAfter20"><label className="labelInput">@{context.participant1}</label></td>
                            <td className="padAfter20"><label className="labelInput">@{context.participant2}</label></td>
                        </tr>
                        <tr>
                            <td className="padAfter20">
                                <TextCurrencyInput 
                                    className="textInput widthViewInput" 
                                    name="amount1" 
                                    value={input.amount1}
                                    onChange={this.changeTextInput}
                                    ethPrice={this.props.ethPrice}
                                    placeholder="Bet amount in ETH"
                                    disabled={disableEditing} 
                                />
                            </td>
                            <td className="padAfter20">
                                <TextCurrencyInput 
                                    className="textInput widthViewInput" 
                                    name="amount2" 
                                    value={input.amount2}
                                    onChange={this.changeTextInput}
                                    ethPrice={this.props.ethPrice}
                                    placeholder="Bet amount in ETH"
                                    disabled={disableEditing} 
                                />
                            </td>
                        </tr>
                        <tr>
                            <td className="padAfter20"><span className="miniText">{input.arbitrationFee === "" ? "" : "+" + input.arbitrationFee + " ETH as arbitration fee"}</span></td>
                            <td className="padAfter20"><span className="miniText">{input.arbitrationFee === "" ? "" : "+" + input.arbitrationFee + " ETH as arbitration fee"}</span></td>
                        </tr>
                    </tbody></table>

                    <table className="moveTop20"><tbody>
                        <tr>
                            <td className="padAfter20"><textarea disabled={disableEditing} placeholder={"Be as specific as possible to explain when @" + context.participant1 + " wins, when @" + context.participant2 + " wins and under what conditions (if any) there is a tie.  Make sure to refer to a specific date if appropriate."} className={"textAreaInput widthTextarea" + (disableEditing ?" disabled" : "")} name="betText" value={input.betText} onChange={this.changeTextInput} /></td>
                        </tr>
                    </tbody></table>

                    <table className="moveTop20"><tbody>
                        <tr>
                            <td className="padAfter20"><label className="labelInput">Arbiter</label></td>
                            <td className="padAfter20"><label className="labelInput">Arbitration fee</label></td>
                        </tr>
                        <tr>
                            <td style={{position:"relative"}} className="padAfter20 alignTop changeArbiterCtn">
                                <input style={{textDecoration:(usernameRequestedArbiter || opponentRequestedArbiter ? "line-through": "none")}} disabled={true} placeholder="Twitter username" type="text" className="textInput widthViewInput changeArbiterDisabled" name="arbiter" value={"@" + input.arbiter} />
                                {!submittedOrFinal && (
                                    <div>
                                        {(!opponentRequestedArbiter && usernameRequestedArbiter) ? (
                                            <div className="inputExplainer">You proposed @{usernameRequestedArbiter} as the new arbiter</div>
                                        ) : (opponentRejectedArbiter ? (
                                            <div className="inputExplainer">@{opponent} rejected changing the arbiter to @{opponentRejectedArbiter}</div>
                                        ) : "")}

                                        {opponentRequestedArbiter && <div className="inputExplainer">@{opponent} proposed @{opponentRequestedArbiter} as the new arbiter</div>}
                                        {!opponentRequestedArbiter && !usernameRequestedArbiter && <div onClick={this.proposeArbiter} className="changeArbiterBtn">Change arbiter</div>}
                                        {!opponentRequestedArbiter && usernameRequestedArbiter && <div onClick={this.cancelNewArbiter} className="cancelArbiterBtn">Cancel proposed arbiter</div>}
                                        {opponentRequestedArbiter && <div onClick={this.reviewArbiter} className="changeArbiterBtn">Review request</div>}
                                    </div>
                                )}
                            </td>
                            <td className="padAfter20 alignTop">
                                <TextCurrencyInput 
                                    className="textInput widthViewInput" 
                                    name="arbitrationFee" 
                                    value={input.arbitrationFee}
                                    onChange={this.changeTextInput}
                                    ethPrice={this.props.ethPrice}
                                    placeholder="Arbitration fee in ETH"
                                    outerClassName=""
                                    disabled={disableEditing} 
                                />                        
                            </td>
                        </tr>
                    </tbody></table>

                    <table className="moveTop20"><tbody>
                        <tr>
                            <td className="padAfter20"><label className="labelInput">Bet expires and bettors get refunds</label></td>
                            <td className="padAfter20"><label className="labelInput">Bettors can request arbitration</label></td>
                        </tr>
                        <tr>
                            <td className="padAfter20" style={{verticalAlign:"top"}}>
                                <DatePickerInput 
                                    onChange={this.handleDateChange}
                                    className="textInput widthViewInput" 
                                    value={input.betExpiresDate} 
                                    disabled={disableEditing} 
                                    hover={false}
                                    name="betExpiresDate"
                                    blankText="Never"
                                    hoverText=""
                                />
                            </td>
                            <td className="padAfter20" style={{verticalAlign:"top"}}>
                                <DatePickerInput 
                                    onChange={this.handleDateChange}
                                    className="textInput widthViewInput" 
                                    value={input.arbitrationRequestDate} 
                                    disabled={disableEditing} 
                                    hover={false}
                                    name="arbitrationRequestDate"
                                    blankText="Any time"
                                    hoverText=""
                                />
                            </td>
                        </tr>
                    </tbody></table>

                    <table className="moveTop20"><tbody>
                        <tr>
                            <td className="padAfter20"><label className="labelInput">Days to respond to arbitration before losing by default</label></td>
                        </tr>
                        <tr>
                            <td className="padAfter20"><input disabled={disableEditing} placeholder="Number of days" type="text" className={"textInput widthViewInput" + (disableEditing ?" disabled" : "")} name="daysBeforeDefaultJudgement" value={input.daysBeforeDefaultJudgement} onChange={this.changeTextInput} /><div className="inputError hide">Please enter number of days</div></td>
                        </tr>
                    </tbody></table>


                    {!submittedOrFinal && !opponentRequestedArbiter && context.step === "VIEW" && (
                    <div>
                        {everyoneAcceptedVersion === 0 && context.yourStatus !== "ACCEPTED" && context.yourStatus !== "REJECTED" && (
                        <div>
                            <div className="normalText moveTop40">Version {selectedVersionNumber}: You haven't replied.</div>
                            <div className="moveTop20">
                                <button disabled={disableButtons} className={"btn btnAccept" + (disableButtons ? " disabled" : "")} onClick={this.acceptVersion}>Accept</button>
                                <button disabled={disableButtons} className={"btn btnReject moveLeft20" + (disableButtons ? " disabled" : "")} onClick={this.rejectVersion}>Reject</button>
                                <button disabled={disableButtons} className={"btn moveLeft20" + (disableButtons ? " disabled" : "")} onClick={this.edit}>Edit</button>
                            </div>
                        </div>
                        )}
                        
                        {everyoneAcceptedVersion === 0 && context.yourStatus === "REJECTED" && (
                        <div>
                            <div className="normalText moveTop40">Version {selectedVersionNumber}: You rejected this version{usernameAcceptedVersion !== 0 && <span>, but accepted <span className="bluelink" onClick={(e) => this.changeSelectedVersion(usernameAcceptedKeyVersion)}>version {usernameAcceptedVersion}</span></span>}.</div>
                            <div className="moveTop20">
                                <button disabled={disableButtons} className={"btn btnAccept" + (disableButtons ? " disabled" : "")} onClick={this.acceptVersion}>Change to accept</button>
                                <button disabled={disableButtons} className={"btn moveLeft20" + (disableButtons ? " disabled" : "")} onClick={this.edit}>Edit</button>
                            </div>
                        </div>
                        )}


                        {everyoneAcceptedVersion === 0 && context.yourStatus === "ACCEPTED" && (
                        <div>
                            <div className="normalText moveTop40">Version {selectedVersionNumber}: You accepted this version.</div>
                            <div className="moveTop20">
                                <button disabled={disableButtons} className={"btn btnReject" + (disableButtons ? " disabled" : "")} onClick={this.rejectVersion}>Change to reject</button>
                                <button disabled={disableButtons} className={"btn moveLeft20" + (disableButtons ? " disabled" : "")} onClick={this.edit}>Edit</button>
                            </div>
                        </div>
                        )}

                        {everyoneAcceptedVersion !== 0 && everyoneAcceptedVersion === selectedVersionNumber && (
                        <div>
                            <div><label className="labelInput moveTop40">Version {selectedVersionNumber}: Everyone has accepted this version.   Finalize in order to deposit funds.</label></div>
                            <div className="moveTop20">
                                <button disabled={disableButtons} className={"btn btnReject" + (disableButtons ? " disabled" : "")}  onClick={this.rejectVersion}>Change to reject</button>
                                <button disabled={disableButtons} className={"btn moveLeft20" + (disableButtons ? " disabled" : "")}  onClick={this.finalize}>Finalize and deploy to blockchain</button>
                            </div>
                        </div>
                        )}

                        {everyoneAcceptedVersion !== 0 && everyoneAcceptedVersion !== selectedVersionNumber && (
                        <div>
                            <div><label className="labelInput moveTop40">Version {selectedVersionNumber}: You rejected this version.  Everyone has accepted <span className="bluelink" onClick={(e) => this.changeSelectedVersion(everyoneAcceptedKeyVersion)}>version {everyoneAcceptedVersion}</span>.</label></div>
                            <div className="moveTop20">
                                <button disabled={disableButtons} className={"btn" + (disableButtons ? " disabled" : "")} onClick={(e) => this.changeSelectedVersion(everyoneAcceptedKeyVersion)}>View version {everyoneAcceptedVersion}</button>
                                <button disabled={disableButtons} className={"btn btnAccept moveLeft20" + (disableButtons ? " disabled" : "")} onClick={this.acceptVersion}>Accept this version instead</button>
                            </div>
                        </div>
                        )}

                    </div>
                    ) }

                    {!submittedOrFinal && !opponentRequestedArbiter && context.step === "EDIT" && (
                    <div>
                        <div><label className="labelInput moveTop40">You are editing a new version.</label></div>
                        <div className="moveTop40">
                            <button disabled={disableButtons} className={"btn" + (disableButtons ? " disabled" : "")} onClick={this.cancelEdit}>Cancel</button>
                            <button disabled={disableButtons} className={"btn moveLeft20" + (disableButtons ? " disabled" : "")} onClick={this.submitVersion}>Submit new version</button>
                        </div>
                    </div>
                    )}

                    {!submittedOrFinal && opponentRequestedArbiter && (
                        <div>
                            <div className="moveTop40">@{opponent} proposed changing the arbiter to @{context.requestedArbiter[opponent]}</div>
                            <button arbiter={context.requestedArbiter[opponent]} disabled={disableButtons} className={"btn btnReject moveTop20" + (disableButtons ? " disabled" : "")} onClick={this.rejectNewArbiter}>Reject @{context.requestedArbiter[opponent]} as arbiter</button>
                            <button arbiter={context.requestedArbiter[opponent]} disabled={disableButtons} className={"btn btnAccept moveTop20 moveLeft20" + (disableButtons ? " disabled" : "")} onClick={this.acceptNewArbiter}>Accept @{context.requestedArbiter[opponent]} as arbiter</button>
                        </div>
                    )}

                </div>

                <div className="sectionNoPadding">
                    <div className="titleCard">Comments</div>
                    <div className="summaryGap"></div>

                    {Object.keys(context.comments || {}).map((index) => {
                        let comment = context.comments[index];
                        return (
                            <div key={index}>
                                <div className="commentTable">
                                    <div className="cardRow"><span className="strongText padTop20">@{comment.username}</span> <span className="lightText padTop20">&nbsp;&nbsp;{comment.hasOwnProperty("createTime") ? comment.createTime : ""}</span></div>
                                    <div className="cardRow">{comment.comment}</div>
                                </div>
                                <div className="summaryGap"></div>
                            </div>);
                    })}

                    <div className="titleCard" style={{backgroundColor:"#fff"}}>
                        <div><textarea disabled={context.pendingComment} placeholder="Leave a comment" className={"textAreaComment widthTextarea" + (context.pendingComment ? " disabled" : "")} name="newComment" value={input.newComment} onChange={this.changeTextInput} /></div>
                        <div><button disabled={context.pendingComment} className={"btn moveTop20 " + (context.pendingComment ? " disabled" : "")} onClick={this.addComment}>Comment</button></div>
                    </div>
                    <div className="summaryGap"></div>

                </div>

            </div>
            );
        }
    }
}
  
export default connect(stateMap)(ViewProposal);



// WEBPACK FOOTER //
// ./src/components/ViewProposal.js